<template>
  <div class="border-box" style="padding: 6px 0 5px 3px;">
    <div class="wrapper">
      <div class="inner" style="padding:0 8px 8px 0;">
        <slot />
      </div>
    </div>
    <img src="../assets/tonghong/border_lt.png" class="corner corner-lt">
    <img src="../assets/tonghong/border_rt.png" class="corner corner-rt" style="top: 6px;">
    <img src="../assets/tonghong/border_rb.png" class="corner corner-rb" style="bottom: 5px;">
    <img src="../assets/tonghong/border_lb.png" class="corner corner-lb">
  </div>
</template>

<script>
export default {
  name: 'BorderBox'
}
</script>

<style lang="scss" scoped>
.border-box {
  position: relative;
  min-width: 100px;
  
  & > .wrapper {
    width: 100%;
    height: 100%;
    border: 1px solid #1c52a7;
    background-color: #0d1d4d;
    .inner {
      position: relative;
      z-index: 2;
      // min-height: 80px;
      height: 100%;
      color: #fff;
      overflow: hidden;
    }
  }
  & > .corner {
    position: absolute;
    z-index: 1;
    &.corner-lt {
      top: 0;
      left: 0;
      width:69px;
      height:51px;
    }
    &.corner-rt {
      right: 0;
    }
    &.corner-rb {
      right: 0;
    }
    &.corner-lb {
      bottom: 0;
      left: 0;
          width:69px;
      height:51px;
    }
  }
}
</style>
